module.exports = __webpack_public_path__ + "static/media/verified.a959a452.svg";